import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  unreadMessagesCount: 0,
  currentConversation: [],
  userTypingData: null,
  chatRooms: [],
  currentChatRoomId: null,
};

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
